import PresentDetailContainer from './PresentDetailContainer';
export default PresentDetailContainer;
